// 提案状态枚举
export const PROPOSAL_STATUS = {
  DRAFT: 'draft',
  ANALYZING: 'analyzing',
  REQUIREMENT_READY: 'requirement_ready',
  CONFIRMED: 'confirmed',
  COMPLETED: 'completed',
  ARCHIVED: 'archived',
} as const;

// 提案状态显示配置
export const PROPOSAL_STATUS_CONFIG: Record<string, { text: string; color: string; description?: string }> = {
  draft: { text: '草稿', color: 'default', description: '提案已创建，尚未开始分析' },
  analyzing: { text: 'AI 分析中', color: 'processing', description: '正在进行 AI 需求分析' },
  requirement_ready: { text: '需求就绪', color: 'warning', description: '需求分析已完成，可继续下一步' },
  confirmed: { text: '已确认', color: 'success', description: '提案需求已确认' },
  // 注意：confirmed 是 Requirement 状态，非 Proposal 本身状态
  // 此处保留是因为 ProposalDetail 页面会将 requirement 的 confirmed 状态传入 getStatusTag
  completed: { text: '已完成', color: 'success', description: '提案所有环节已完成' },
  archived: { text: '已归档', color: 'default', description: '提案已归档' },
};

// 提案状态筛选选项（用于下拉框）
export const PROPOSAL_STATUS_OPTIONS = Object.entries(PROPOSAL_STATUS_CONFIG).map(([value, config]) => ({
  value,
  label: config.text,
}));

// AI 任务状态显示配置
export const AI_TASK_STATUS_CONFIG: Record<string, { text: string; color: string }> = {
  pending: { text: '待处理', color: 'default' },
  processing: { text: '处理中', color: 'processing' },
  generating: { text: '生成中', color: 'processing' },
  draft: { text: '待确认', color: 'warning' },
  confirmed: { text: '已确认', color: 'success' },
  completed: { text: '已完成', color: 'success' },
  failed: { text: '失败', color: 'error' },
};
